import classnames from 'classnames'
import React from 'react'
import { FORM_REFS } from '../../../constants'
import { aemHostClient, taxonomyHostClient } from '../../../restClient'
import { Translations, isEmptyObject } from '../../../utils'
import { NavListAccordionWrapper } from '../../common/CaseDetailAccordion/caseDetailAccordion'
import NavListAccordion from '../../common/NavListAccordion/NavListAccordion'
import Panel from '../../common/Tabs/Panel'
import Tabs from '../../common/Tabs/Tabs'
import CaptureAccountDetails from './CaptureAccountDetails'
import CaptureCustomerBasicDetails from './CaptureCustomerDetails'
import "./index.css"

const SowEditEntityPageUrl = "/aemData/formData/json_edit-sow-entity-basic-details-page"
const SowAccountDetailsPageUrl = "/aemData/formData/json_sow-account-details"

class CustomerDetails extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            customerDetailsFormJson: undefined,
            accountDetailsFormJson: undefined,
            accountsTaxonomies: {},
            cachedResourceData: {}
        }
    }

    componentWillMount() {
        aemHostClient(SowEditEntityPageUrl)
            .then(({ data }) => {
                document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`;
                this.setState({ customerDetailsFormJson: data })
                this.props.blockUi && this.props.blockUi()
                return data
            }).then(async (pageJson) => {
                const resourceData = {}
                if (pageJson && pageJson.par &&
                    pageJson.par.aemform_ && pageJson.par.aemform_.formRef) {
                    const apiUrl = FORM_REFS[pageJson.par.aemform_.formRef]
                    try {
                        const { data: formJsonResponse } = await aemHostClient(apiUrl)
                        resourceData.formSchema = formJsonResponse
                        if (formJsonResponse.guideContainer.rootPanel.items.guidedropdownlist_countryOfIncorporation.apiUrl) {
                            const dropdownApiUrl = this.getTranslations(formJsonResponse.guideContainer.rootPanel.items.guidedropdownlist_countryOfIncorporation.apiUrl)
                            const { data: countryDropDownData } = await aemHostClient(dropdownApiUrl)
                            resourceData.dropdown_countryOfIncorporation = countryDropDownData
                        }
                        this.setState({
                            cachedResourceData: resourceData
                        })
                        this.props.unBlockUi && this.props.unBlockUi()
                    }
                    catch (err) {
                        console.log(err)
                        this.props.unBlockUi && this.props.unBlockUi()
                    }
                }
            })
        aemHostClient(SowAccountDetailsPageUrl)
            .then(({ data }) => {
                // document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`;
                this.setState({ accountDetailsFormJson: data });
            });

        this.getAccountsAllTaxonomies()
    }

    getAccountsAllTaxonomies = () => {
        const groupAccountCountryTaxonomyApiUrl = "/taxonomies/groups/account";
        const partyAccountCountryTaxonomyApiUrl = "/taxonomies/party/countries";
        const partyAccountCurrencyTaxonomyApiUrl = "/product/taxonomies/urn:hsbc:cmb:gdocs:products:taxonomies:AllCurrency";


        Promise.all([
            this.getAccountsTaxonomies(groupAccountCountryTaxonomyApiUrl, "groupCountry"),
            this.getAccountsTaxonomies(partyAccountCountryTaxonomyApiUrl, "partyCountry"),
            this.getAccountsTaxonomies(partyAccountCurrencyTaxonomyApiUrl, "partyCurrency")
        ]).then(resArray => {
            const accountsTaxonomies = {}

            resArray.forEach(({ data = {}, type = '' }) => {
                if (type) {
                    accountsTaxonomies[type] = typeof type === "string" && type.includes("Country") ? data.countryTaxonomy.classificationNodes :
                        data.classificationNodes
                }
            })

            if (!isEmptyObject(accountsTaxonomies)) {
                this.setState({
                    accountsTaxonomies
                })
            }
        })
    }

    getAccountsTaxonomies = (apiUrl = '', type = '') => {
        if (apiUrl && type) {
            this.props.blockUi && this.props.blockUi()
            return taxonomyHostClient(apiUrl)
                .then(({ data }) => {
                    this.props.unBlockUi && this.props.unBlockUi()
                    const { responseData } = data || {}
                    return { data: responseData, type }
                });
        }
    }

    getTranslations = (word) => {
        return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    }

    render() {
        const { tabs: {
            activeTabId = 0
        }, setCurrentActiveTab, translateWord, lang, entities = [], customerPageJson, history } = this.props

        return (
            <article>
                <section>
                    <button class="gdocs-btn-default"
                        disabled={this.props.btnDisabled || (this.props.isReadOnly && this.props.isReadOnly())}
                        onClick={() => { this.props.history.push("/edit-a-sow/entities", { navigatedFrom: "/sow-body", action: "add-customer" }) }}><span className="icon icon-add addicon" aria-hidden="true"></span>Add Customer</button>
                </section>
                <section className='entities-accordion-container'>
                    <section>
                        <h5 className="customers-name">
                            {Translations(this.props.customerPageJson.navigation_list_customerList.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                        </h5>
                    </section>
                    <section className='sow-customer-list-container'>
                        {
                            Array.isArray(this.props.entities) && this.props.entities.length ?
                                this.props.entities.map((entity, entityIndex) => (
                                    <NavListAccordionWrapper block={this.props.btnDisabled} open={this.props.activeCustomerAccordionIndex}
                                        key={"entity-" + entityIndex}
                                    >
                                        <NavListAccordion
                                            lang={this.props.lang.currentLang.lang}
                                            navAccHeading={`${entity.registeredName} - ${entity.countryOfIncorporation.name}`}
                                            status={this.props.getStatusLabel(this.props.sowTabStatus, "entitiesStatus", entityIndex, undefined, "status", false)}
                                            _onClick={() => this.props.activeCustomerAccordionIndex === entityIndex ? this.props.setSowBodyCustomerActiveTabIndex(undefined)
                                                : this.props.setSowBodyCustomerActiveTabIndex(entityIndex)}
                                        >
                                            <article>
                                                <section className="basic-details-section">
                                                    <section className='basic-details-accordion-data'>
                                                        <Tabs
                                                            selected={activeTabId[entityIndex] && activeTabId[entityIndex]["activeSubTab"]}
                                                            useReduxHandler={true}
                                                            setCurrentActiveTab={(index) => setCurrentActiveTab(entityIndex, index)}
                                                            ariaSelected={activeTabId[entityIndex] && activeTabId[entityIndex]["activeSubTab"]}
                                                        >
                                                            <Panel
                                                                label={translateWord(this.props.customerPageJson.tab_pageTab_customer_details_subTab.text)[0]}
                                                                status={this.props.getStatusLabel(this.props.sowTabStatus, "entitiesStatus", entityIndex, 0)}
                                                                disabled={this.props.btnDisabled}
                                                            >
                                                                <CaptureCustomerBasicDetails
                                                                    history={history}
                                                                    customerPageJson={customerPageJson}
                                                                    entities={entities}
                                                                    lang={lang}
                                                                    location={history.location}
                                                                    activeEntity={Array.isArray(entities) && entities.length
                                                                        && entities[entityIndex]}
                                                                    customerDetailsFormJson={this.state.customerDetailsFormJson}
                                                                    blockUi={this.props.blockUi}
                                                                    unBlockUi={this.props.unBlockUi}
                                                                    getSowDetails={this.props.getSowDetails}
                                                                    getTabStatus={this.props.getTabStatus}
                                                                    idPrefix={"sow-entity-" + entityIndex}
                                                                    customer={this.props.customer}
                                                                    isCustAck={this.props.isCustAck}
                                                                    isRepeatingComponentWithSameResourceUrl={true}
                                                                    cachedResourceData={this.state.cachedResourceData}
                                                                    isReadOnly={this.props.isReadOnly}
                                                                />
                                                            </Panel>
                                                            <Panel
                                                                label={translateWord(customerPageJson.tab_pageTab_customer_details_subTab.text)[1]}
                                                                status={this.props.getStatusLabel(this.props.sowTabStatus, "entitiesStatus", entityIndex, 1)}
                                                                disabled={this.props.btnDisabled}
                                                            >
                                                                <CaptureAccountDetails
                                                                    history={history}
                                                                    customerPageJson={customerPageJson}
                                                                    entities={entities}
                                                                    lang={lang}
                                                                    accountDetailsFormJson={this.state.accountDetailsFormJson}
                                                                    blockUi={this.props.blockUi}
                                                                    unBlockUi={this.props.unBlockUi}
                                                                    activeEntity={Array.isArray(entities) && entities.length
                                                                        && entities[entityIndex]}
                                                                    getTabStatus={this.props.getTabStatus}
                                                                    idPrefix={"sow-entity-" + entityIndex}
                                                                    accountsTaxonomies={this.state.accountsTaxonomies}
                                                                    customer={this.props.customer}
                                                                    isCustAck={this.props.isCustAck}
                                                                    isReadOnly={this.props.isReadOnly}
                                                                />
                                                            </Panel>
                                                        </Tabs>
                                                    </section>
                                                </section>
                                            </article>
                                        </NavListAccordion>
                                    </NavListAccordionWrapper>
                                )) : null
                        }

                    </section>

                </section>
            </article >
        )
    }
}
const NavlistWrapper = (props) => {
    const navListWrapper = classnames("nav-list-wrapper", {
        block: props.block
    });
    return (
        <div className={navListWrapper}>
            <div className="nav-list-blocker"></div>
            {props.children}
        </div>
    )
}
export default CustomerDetails


// WEBPACK FOOTER //
// ./src/components/SowBody/CustomerDetails/index.js